import Hero from "../Component/Hero";
import DownloadAppSection from "../../../Components/DownloadAppSection";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";
import Riplay from "../Component/Riplay";

function PinjamanKaryawan() {
    return (
        <>
            <div>
                <Hero
                    imageClass='pinjaman-karyawan'
                    title='<em>Employee Benefit Program</em>'
                    subTitle='P I N J A M A N &emsp;I N D I V I D U'
                    explanation='
                        Adalah fasilitas pinjaman tanpa agunan untuk karyawan aktif yang bekerja pada perusahaan yang telah bermitra dengan Danai.id, dimana jangka waktu pinjaman sampai 2 tahun dengan pembayaran angsuran bulanan.'
                    buttonText='AJUKAN PINJAMAN'
                />
                <Table type='individu' title='pinjaman-karyawan'/>
                {/* <PersyaratanPinjaman type='individu' product='pinjaman-karyawan'/>
                <CardDokumenPendukung type='individu' product='pinjaman-karyawan'/> */}
                <PengajuanPinjaman type='individu'/>
                <Riplay type='individu' product='ebp'/>
                <DownloadAppSection/>
            </div>
        </>
    );
}

export default PinjamanKaryawan;
